import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";

import endpoints from "@/endpoints";

export const useFetchCustomData = () => {
    const queryClient = useQueryClient();

    const { data: customData, isLoading: loadingCustomData } = useQuery("customData", async () => {
        const response = await axios.get(endpoints.getCalcPanelList);
        return response.data;
    });

    const { mutate: setCustomData, status: setCustomDataStatus } = useMutation(
        async (newData: any) => {
            const response = await axios.post(endpoints.getCalcPanelList, newData);
            return response.data;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries("customData");
            },
        }
    );

    return { customData, loadingCustomData, setCustomData, setCustomDataStatus };
};

export const useFetchElementData = (id: string, customData: any) => {
    const customDataFilter = customData?.data?.list?.find((item: any) => item.id === id);

    const { data: elementData, isLoading: loadingPage } = useQuery(
        ["elementData", id],
        async () => {
            if (customDataFilter !== undefined) {
                const response = await axios.get(`${endpoints.getCalcPanelById}?url=https://${customDataFilter?.url}`);
                return response.data;
            }
        },
        {
            enabled: !!customDataFilter,
        }
    );

    return { elementData, loadingPage };
};

export const useUpdateCalcPanel = () => {
    const queryClient = useQueryClient();

    const {
        mutate: updateCalcPanel,
        status: updateStatus,
        isLoading: updateLoading,
    } = useMutation(
        async (newData: any) => {
            const response = await axios.patch(endpoints.updateCalcPanel, newData);
            return response.data;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries("customData");
                queryClient.invalidateQueries("elementData");
            },
        }
    );

    return { updateCalcPanel, updateStatus, updateLoading };
};

export const useActivateCalcPanel = () => {
    const queryClient = useQueryClient();

    const {
        mutate: activateCalcPanel,
        status: activateStatus,
        isLoading: activateLoading,
    } = useMutation(
        async (data: { url: string; data: { name: string; content: string } }) => {
            const response = await axios.post(endpoints.activateCalcPanel, data);
            return response.data;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries("customData");
                queryClient.invalidateQueries("elementData");
            },
        }
    );

    return { activateCalcPanel, activateStatus, activateLoading };
};

export const useDeleteCalcPanel = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteCalcPanel,
        status: deleteStatus,
        isLoading: deleteLoading,
    } = useMutation(
        async (url: string) => {
            const response = await axios.delete(`${endpoints.deleteCalcPanel}?url=https://${url}`);
            return response.data;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries("customData");
                queryClient.invalidateQueries("elementData");
            },
        }
    );

    return { deleteCalcPanel, deleteStatus, deleteLoading };
};
